module.exports = __webpack_public_path__ + "img/home-premium-3.ff945ee3.png";